import api from '@/api/crm'

const state = {
  talentPoolSearchCondition: {
    creator: 'all',
    visibility: 'all'
  },
  micrositeAdditionalInfo: {}
}

const actions = {
  searchTag ({ commit }, params) {
    return api.searchTag(params)
  },
  getTagById ({ commit }, id) {
    return api.getTagById(id)
  },
  createTag ({ commit }, tag) {
    return api.createTag(tag)
  },
  updateTag ({ commit }, tag) {
    return api.updateTag(tag)
  },
  deleteTag ({ commit }, id) {
    return api.deleteTag(id)
  },
  searchMicrosite ({ commit }, params) {
    return api.searchMicrosite(params)
  },
  getMicrositeById ({ commit }, id) {
    return api.getMicrositeById(id)
  },
  createMicrosite ({ commit }, microsite) {
    return api.createMicrosite(microsite)
  },
  updateMicrosite ({ commit }, microsite) {
    return api.updateMicrosite(microsite)
  },
  deleteMicrosite ({ commit }, id) {
    return api.deleteMicrosite(id)
  },
  copyMicrosite ({ commit }, { formId, newSite }) {
    return api.copyMicrosite(formId, newSite)
  },
  publishMicrosite ({ commit }, microsite) {
    return api.publishMicrosite(microsite.id, microsite.is_publish)
  },
  searchCampaign ({ commit }, params) {
    return api.searchCampaign(params)
  },
  getCampaignById ({ commit }, { campaignId, params }) {
    return api.getCampaignById(campaignId, params)
  },
  createCampaign ({ commit }, campaign) {
    return api.createCampaign(campaign)
  },
  updateCampaign ({ commit }, campaign) {
    return api.updateCampaign(campaign)
  },
  deleteCampaign ({ commit }, id) {
    return api.deleteCampaign(id)
  },
  getCampaignReport ({ commit }, params) {
    return api.getCampaignReport(params)
  },
  searchCampaignNotificationMessage ({ commit }, params) {
    return api.searchCampaignNotificationMessage(params)
  },
  searchCampaignNotification ({ commit }, { campaignId, params }) {
    return api.searchCampaignNotification(campaignId, params)
  },
  sendCampaignNotification ({ commit }, { campaignId, notification }) {
    return api.sendCampaignNotification(campaignId, notification)
  },
  exportCampaignReport ({ commit }, exportData) {
    return api.exportCampaignReport(exportData)
  },
  createDownloadFile ({ commit }, response) {
    return api.createDownloadFile(response)
  },
  getMicrositeCompanyInfo ({ commit }, siteId) {
    return api.getMicrositeCompanyInfo(siteId)
  },
  getMicrositeCampaignCompanyInfo ({ commit }, siteId) {
    return api.getMicrositeCampaignCompanyInfo(siteId)
  },
  changeTalentPoolSearchCondition ({ commit }, params) {
    commit('CHANGE_TALENT_POOL_SEARCH_CONDITION', params)
  },
  changeAccountMicrositeAdditionalInfo ({ commit }, params) {
    commit('MICROSITE_ADDITIONAL_INFO', params)
  },
  searchTagTask ({ commit }, params) {
    return api.searchTagTask(params)
  },
  getTagTaskById ({ commit }, id) {
    return api.getTagTaskById(id)
  },
  createTagTask ({ commit }, task) {
    return api.createTagTask(task)
  },
  updateTagTask ({ commit }, task) {
    return api.updateTagTask(task)
  },
  deleteTagTask ({ commit }, id) {
    return api.deleteTagTask(id)
  },
  saveCandidateTag ({ commit }, { candidateId, params }) {
    return api.saveCandidateTag(candidateId, params)
  },
  addCandidateTag ({ commit }, params) {
    return api.addCandidateTag(params)
  },
  deleteCandidateTag ({ commit }, { candidateId, data }) {
    return api.deleteCandidateTag(candidateId, data)
  },
  getMicrositeGroupList ({ commit }, params) {
    return api.getMicrositeGroupList(params)
  },
  getMicrositeGroupById ({ commit }, groupId) {
    return api.getMicrositeGroupById(groupId)
  },
  createMicrositeGroup ({ commit }, params) {
    return api.createMicrositeGroup(params)
  },
  updateMicrositeGroup ({ commit }, params) {
    return api.updateMicrositeGroup(params)
  },
  deleteMicrositeGroup ({ commit }, groupId) {
    return api.deleteMicrositeGroup(groupId)
  }
}

const mutations = {
  CHANGE_TALENT_POOL_SEARCH_CONDITION (state, params) {
    state.talentPoolSearchCondition[params.key] = params.value
  },
  MICROSITE_ADDITIONAL_INFO (state, params) {
    state.micrositeAdditionalInfo[params.id] = params.info
  }
}

const getters = {
  getTalentPoolSearchCondition (state) {
    return state.talentPoolSearchCondition
  },
  getMicrositeAdditionalInfo (state) {
    return state.micrositeAdditionalInfo
  }
}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
